import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
flex-wrap: wrap;
width: 100%;
height: 100%;
position: relative;
`;